module.exports = __webpack_public_path__ + "faq/img/class_active.b7c5bf47.png";